module.exports = __webpack_public_path__ + "static/img/line_up_bg.6d7b3568.png";